export { SeoText } from './SeoText';
